import { Link } from "react-router-dom";
import { STAGES } from "@/mocks/archive";

export default function Process() {
  return (
    <section id="process" className="relative overflow-hidden bg-primary-950 py-16 md:py-20">
      <span className="pointer-events-none absolute -right-10 top-6 font-heading text-[10rem] leading-none text-background-50/[0.04] select-none">TA</span>
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 relative">
        <div className="grid gap-8 lg:gap-12 lg:grid-cols-[0.9fr_1.4fr] lg:items-center">
          {/* 左：标题 */}
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-accent-400 uppercase">
              <span className="h-px w-8 bg-accent-500" /> How It Unfolds
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">
              一场塌房的<br />完整全过程
            </h2>
            <p className="mt-4 max-w-md text-sm md:text-base leading-7 text-primary-100/80">
              没有一场塌房是毫无征兆的。从暗流涌动到全面清算，我们把过程拆成四个阶段，
              帮你读懂每一个瓜背后的公共情绪与行业逻辑。
            </p>
            <Link
              to="/archive"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-accent-500 text-primary-950 px-5 py-2.5 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              用分类档案对照全过程 <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>

          {/* 右：四阶段 */}
          <div className="grid gap-4 sm:grid-cols-2">
            {STAGES.map((s, i) => (
              <div key={s.title} className="group relative rounded-xl border border-primary-800 bg-primary-900/40 p-5 transition-colors hover:border-accent-500/60">
                <div className="flex items-center justify-between">
                  <span className={`grid place-items-center w-10 h-10 rounded-lg ${i === 1 ? "bg-accent-500 text-primary-950" : "bg-primary-800 text-accent-300"}`}>
                    <i className={`${s.icon} text-lg`} />
                  </span>
                  <span className="font-heading text-3xl font-black text-primary-800 tabular-nums">0{i + 1}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-background-50">{s.title}</h3>
                <p className="mt-2 text-xs md:text-sm leading-6 text-primary-100/75">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}